import { render } from "./StartHubTicketsCard.vue?vue&type=template&id=52637085"
import script from "./StartHubTicketsCard.vue?vue&type=script&lang=js"
export * from "./StartHubTicketsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__